/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_N3Inputs */

const en_to_xml_ref_n3 = /** @type {(inputs: To_Xml_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Null becomes a self closing element. An empty object and an empty array produce the same thing.`)
};

const ko_to_xml_ref_n3 = /** @type {(inputs: To_Xml_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null은 자기 종결 요소가 됩니다. 빈 객체와 빈 배열도 같은 결과입니다.`)
};

const ja_to_xml_ref_n3 = /** @type {(inputs: To_Xml_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null は自己終了要素になります。空のオブジェクトと空の配列も同じ結果です。`)
};

/**
* | output |
* | --- |
* | "Null becomes a self closing element. An empty object and an empty array produce the same thing." |
*
* @param {To_Xml_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_n3 = /** @type {((inputs?: To_Xml_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_n3(inputs)
	if (locale === "ko") return ko_to_xml_ref_n3(inputs)
	return ja_to_xml_ref_n3(inputs)
});